import React from "react";
import { Tooltip } from "../../utils/local-antd";
import { Flex } from "../Flex";
import { useTranslation } from "react-i18next";
import { Button } from "../Button";
import { TextWithTruncated } from "../TextWithTruncated";
import styled, { DefaultTheme } from "styled-components";
import capitalize from "lodash/capitalize";
import { isValidUrl } from "../../utils/String";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons/faUpRightFromSquare";
import { Spacing } from "../../theme/Spacing";
import { Rounded } from "../../theme/Rounded";
import { CopyButton } from "../CopyButton";
import { EntryKind } from "../../model/entry/types/EntryKind.enum";

const Container = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.s};
  padding: ${Spacing.xs};
  border-radius: ${Rounded.md};
`;

const SourceButton = styled(Button)<{ $kind?: EntryKind }>`
  padding: 0;
  margin: 0;
  background-color: ${({ theme }) => theme.white};
  border-radius: ${Rounded.circle};
  height: 2rem;
  width: 2rem;
  color: ${({ theme, $kind }) =>
    $kind ? theme[$kind.toLowerCase() as keyof DefaultTheme] : theme.black};
`;

const StyledCopyButton = styled(CopyButton)<{ kind?: EntryKind }>`
  margin: 0 !important;
  padding: 0 !important;
  background-color: ${({ theme }) => theme.white};
  border-radius: ${Rounded.circle};
  height: 2rem;
  width: 2rem;

  svg {
    color: ${({ theme, kind }) =>
      kind ? theme[kind.toLowerCase() as keyof DefaultTheme] : theme.black};
  }

  &:hover {
    background-color: ${({ theme }) => theme.white};
  }
`;

type Props = {
  link?: string;
  extra?: {
    kind?: EntryKind;
  };
};

export const TableActionableLink: React.FC<Props> = ({ link = "", extra }) => {
  const { t } = useTranslation();

  const isURL = isValidUrl(link);

  if (!link?.length) {
    return null;
  }

  return (
    <Container className="actionable-cell">
      <Flex gap="s" alignItems="center">
        {isURL ? (
          <Tooltip title={t("common.openInNewTab")}>
            <SourceButton
              onClick={() => window.open(link, "_blank")}
              icon={faUpRightFromSquare}
              iconWidth="lg"
              $kind={extra?.kind}
            />
          </Tooltip>
        ) : null}
        <TextWithTruncated length={20} direction="ltr">
          {isURL
            ? link
            : capitalize(link === "direct" ? t("common.direct") : link)}
        </TextWithTruncated>
        <StyledCopyButton copy={link} iconSize="lg" kind={extra?.kind} />
      </Flex>
    </Container>
  );
};
